import React, { useEffect } from 'react';
import styles from './index.module.scss';
import Cookies from 'js-cookie';

const Home: React.FC = () => {
  useEffect(() => {
    const origin = window.location.origin;
    window.assistantConfig = {
      showChat: false,
    };
    window.navigationAssistantConfig = {
      staffId: 3961,
      tenantMcid: '97cfc70b-e6f0-44c0-8ba3-804dc61e447a',
      showChat: true,
      GT: 'GT-a8FKHf5GpW1xZYiw7fn2LEdnkCSQ2rCJJX3GJjmO',
      baseUrl: window.location.origin,
      type: 'navigation',
      hasHistory: false,
      // theme: 'dark',
    };
    // 使用预设场景
    // window.assistantConfig.mock = { scenario: 'withThinking' };

    if (
      window.assistantEmbed ||
      document.getElementById('test') ||
      document.getElementById('default-assistant-script')
    ) {
      return;
    }

    const script = document.createElement('script');
    script.src = `${origin}/embed.js`;
    script.id = 'test';
    script.defer = true;
    document.body.appendChild(script);
  }, []);
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>欢迎来到 智慧能源助手</h1>
      <p className={styles.description}>
        我是您的智慧能源小助手，支持图表生成、业务问题诊断、页面分析等功能，快来探索吧～
      </p>
    </div>
  );
};

export default Home;
